import { OmrHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const PutOrgUnitBulkRenewalOptInData = (orgUnitId, optInObj, state, setState) => {
  if (state.isSaving !== true && orgUnitId && !state.message) {
    const newState = {
      ...state,
      orgUnitId,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const orgUnitIdForUrl = orgUnitId ? encodeURIComponent(orgUnitId) : 'NaN';

    const url = `/OrgUnitBulkRenewalOptIn/OrgUnit/${orgUnitIdForUrl}`;
    OmrHttpHelper(url, 'PUT', optInObj)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            orgUnitId,
            isObjLoaded: true,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default PutOrgUnitBulkRenewalOptInData;